import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {RealNumberRounded} from '../../../utils/NumeralParts';
import Formatters from '../../shared/utils/Formatters';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import { TrackEventName } from '../../shared/constants/SegmentEvents';
import isEmpty from "is-empty";
import {connect} from 'react-redux';

class OpportunityRow extends Component {
  constructor(props) {
    super(props)

    this.trackSegmentClick = this.trackSegmentClick.bind(this);
    this.renderRightButton = this.renderRightButton.bind(this);
    this.trackCreditLineButton = this.trackCreditLineButton.bind(this);
  }

  trackSegmentClick() {
    const {project_name, url_address, category_description} = this.props

    const payload = {
      project_name: project_name,
      url: url_address,
      category: category_description
    }

    segmentEventTracker.trackEvent(TrackEventName.PROJECT_DETAILS_CLICKED, payload);
  }

  trackCreditLineButton() {
    segmentEventTracker.trackEvent(TrackEventName.CREDIT_LINE_BUTTON_CLICKED);
  }

  renderRightButton() {
    const utmValues = '?utm_source=project-finder&utm_medium=direct&utm_campaign=project-finder&utm_id=fc-project-finder';
    const creditLineUrl = `${process.env.REACT_APP_OB_APP_URL}${utmValues}`;
    const pathName = isEmpty(this.props.user.id) ? creditLineUrl : "/draw_down"

    return (
      <Link to={{pathname: pathName}}
        target="_blank"
        data-testid="credit-line-button"
        className="ds-btn -secondary --small _simple _widthAuto _margin--small"
        onClick={this.trackCreditLineButton}>
        Apply for Credit Line
      </Link>
    )
  }

  render() {
    const {project_details} = this.props;

    let procuring_entity = "";
    let published_date = ""

    const parsed_project_details = JSON.parse(project_details);

    if (parsed_project_details.length > 0) {
      procuring_entity = parsed_project_details[0].procuring_entity;
      published_date = parsed_project_details[0].published_date;
    }

    const amount = RealNumberRounded({ number: this.props.bid_amount })

    return (
      <tr>
        <td colSpan={2}>{this.props.project_name}</td>
        <td colSpan={2}>₱{amount}</td>
        <td colSpan={2}>{this.props.address}</td>
        <td>{procuring_entity}</td>
        <td>{Formatters.date(published_date, "DD/MM/YYYY")}</td>
        <td colSpan={2}>{Formatters.dateTime(this.props.closing_date)}</td>
        <td className="row-actions">
          <Link to={{pathname: this.props.url_address}}
            target="_blank"
            data-testid="opportunitiy-details-button"
            className="ds-btn --small _simple _widthAuto _margin--small"
            onClick={this.trackSegmentClick}>
            Details
          </Link>

          {this.renderRightButton()}
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(OpportunityRow);



// WEBPACK FOOTER //
// ./src/features/projectFinder/components/OpportunityRow.js